import { Grid, GridProps } from '@mui/material';

export type CompactGridItemProps = Omit<GridProps, 'item' | 'width' | 'maxWidth'>;

export function CompactGridItem(props: CompactGridItemProps) {
  return (
    <Grid container size={12}>
      <Grid
        sx={[
          {
            width: '100%',
            maxWidth: 750,
          },
        ]}
        {...props}
      />
    </Grid>
  );
}
